import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-expense-policy-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbTooltip, NgbDatepickerModule],
  providers: [DatePipe,
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './expense-policy-form.component.html',
  styleUrl: './expense-policy-form.component.scss'
})
export class ExpensePolicyFormComponent {
  isDisabled: boolean = false;
  user = [] as any;
  Applicabilitys = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  ExpenseCategorys = [] as any;
  Vehicles = [] as any;
  LastWebESSApplicabilityId = null;

  Expense = {
    SelectType: 'insert',
    ESS_ExpenseRuleID: 0,
    RuleName: null,
    Description: null,
    Attachment: 'No',
    IsReportToBeSubmittedBefore: false,
    ReportToBeSubmittedBefore: 0 as any,
    ESS_ExpenseCategoryLimitationsRule: [
      // {
      //   ESS_ExpenseCategoryMasterId: null,
      //   EffectiveDate: null as any,
      //   EffectiveDateObj: null as any,
      //   MaxExpenseAmountLimit: null,
      //   MaxExpenseCount: null,
      //   IsReceiptRequired: false,
      //   ReceiptRequiredLimit: null,
      //   MakeDescriptionMandatory: false,
      //   ExpenseCategoryAtActual: false,
      // }
    ] as any,
    ESS_ExpenseMilageLimitationsRule: [
      // {
      //   ESS_VehicleMasterId: null,
      //   EffectiveDate: null as any,
      //   EffectiveDateObj: null as any,
      //   MileageRate: null,
      //   MileageLimit: null,
      //   ExpenseMilageAtActual: false,
      // }
    ] as any,
    DefaultRule: false,
    EmpType: 'FRONT',
    TravelType: 'Local' as any,//Local , Outstation
    LastSelectedTravelType: 'Local',//Local , Outstation
    LimitType: 'Monthly',//Daily ,Monthly , Quarterly ,Yearly
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }

  States = [] as any;
  StatesFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  constructor(
    private session: SessionService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private router: Router,
    protected common: CommonService,
    protected tooltip: TooltipService,
    private approvalMatrix: ApprovalMatrixService,
    private combo: ComboService,
    private expense: ExpenseService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Expense.ESS_ExpenseRuleID = parseInt(params['id']));
  }

  ngOnInit(): void {
    if (this.Expense.ESS_ExpenseRuleID > 0) {
      this.ESS_ExpenseRule_LoadUpdate();
    } else {
      this.ESS_ExpenseCategoryMasterSelect();
      this.ESS_VehicleMasterSelect();
      this.GetApplicability();
    }
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_ExpenseRule_InsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.Expense.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.Expense.WebESSApplicabilityId).length == 0) {
          this.Expense.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.Expense.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.AttendanceRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.Expense.MappedId = null;
        this.LastWebESSApplicabilityId = this.Expense.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.Expense.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.Expense.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.Expense.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.Expense.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.Expense.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.Expense.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.Expense.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.Expense.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.Expense.WebESSApplicabilityId == 3 || this.Expense.WebESSApplicabilityId == 4 || this.Expense.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.ClientGroupMasterID,
                ApplicabilityData: element.ClientGroupName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.SiteMasterID,
                ApplicabilityData: element.SiteName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: this.Expense.MappedId != null ? this.Expense.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.Expense.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent);
    modalRef.componentInstance.Title = this.Expense.WebESSApplicabilityId == 3 ? 'Client' : this.Expense.WebESSApplicabilityId == 4 ? 'Site' : this.Expense.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.Expense.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.Expense.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.Expense.WebESSApplicabilityId == 3 || this.Expense.WebESSApplicabilityId == 4 || this.Expense.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.Expense.WebESSApplicabilityId == 4 || this.Expense.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.Expense.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.Expense.WebESSApplicabilityId == 8) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.Expense.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.Expense.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.Expense.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.Expense.WebESSApplicabilityId == 4) {
        this.ApprovalComboLoad('Site');
      } else if (this.Expense.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.Expense.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.Expense.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.Expense.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  ComboLoad(Combotype: String, id: number) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': id, 'EmpType': this.Expense.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  addMileageLimitation() {
    this.Expense.ESS_ExpenseMilageLimitationsRule.push({
      ESS_VehicleMasterId: null,
      EffectiveDate: null,
      EffectiveDateObj: null,
      MileageRate: null,
      MileageLimit: null,
      IsReceiptRequired: false,
      ReceiptRequiredLimit: null,
      MakeDescriptionMandatory: false,
      ExpenseMilageAtActual: false,
    });
  }

  deletMileageLimitation(index: number) {
    this.Expense.ESS_ExpenseMilageLimitationsRule.splice(index, 1);
  }

  addCategory() {
    this.Expense.ESS_ExpenseCategoryLimitationsRule.push({
      ESS_ExpenseCategoryMasterId: null,
      EffectiveDate: null,
      EffectiveDateObj: null,
      MaxExpenseAmountLimit: null,
      MaxExpenseCount: null,
      IsReceiptRequired: false,
      ReceiptRequiredLimit: null,
      MakeDescriptionMandatory: false,
      ExpenseCategoryAtActual: false,
    });
  }

  deleteCategory(index: number) {
    this.Expense.ESS_ExpenseCategoryLimitationsRule.splice(index, 1);
  }

  ESS_ExpenseCategoryMasterSelect() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseCategoryMasterSelect({ ESS_ExpenseCategoryMasterId: 0, SelectType: 1, TravelType: this.Expense.TravelType }).subscribe({
      next: (response) => {
        this.ExpenseCategorys = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_VehicleMasterSelect() {
    this.isDisabled = true;
    this.expense.ESS_VehicleMasterSelect({ ESS_VehicleMasterId: 0, SelectType: 1, TravelType: this.Expense.TravelType }).subscribe({
      next: (response) => {
        this.Vehicles = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  TravelTypeChanges(event: any) {
    if (this.Expense.ESS_ExpenseCategoryLimitationsRule.length > 0 || this.Expense.ESS_ExpenseMilageLimitationsRule.length > 0) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'All Category and Mileage Limitation Delete. Do you want to change?';
      modalRef.result.then((result) => {
        if (result) {
          this.Expense.LastSelectedTravelType = this.Expense.TravelType;
          this.Expense.ESS_ExpenseCategoryLimitationsRule = [];
          this.Expense.ESS_ExpenseMilageLimitationsRule = [];

          this.ESS_ExpenseCategoryMasterSelect();
          this.ESS_VehicleMasterSelect();
        } else {
          this.Expense.TravelType = this.Expense.LastSelectedTravelType;
        }
      });
    } else {
      this.ESS_ExpenseCategoryMasterSelect();
      this.ESS_VehicleMasterSelect();
    }
  }

  ESS_ExpenseRule_LoadUpdate() {
    this.isDisabled = true;
    this.expense.ESS_ExpenseRule_LoadUpdate({ SelectType: 1, ESS_ExpenseRuleId: this.Expense.ESS_ExpenseRuleID }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.Expense = response.Table[0];
        this.Expense.ESS_ExpenseCategoryLimitationsRule = response.Table1;
        this.Expense.ESS_ExpenseCategoryLimitationsRule.forEach((element: any) => {
          element.EffectiveDateObj = this.dateFormat.parse(element.EffectiveDate);
        });

        this.Expense.ESS_ExpenseMilageLimitationsRule = response.Table2;
        this.Expense.ESS_ExpenseMilageLimitationsRule.forEach((element: any) => {
          element.EffectiveDateObj = this.dateFormat.parse(element.EffectiveDate);
        });

        this.Expense.MappedId = response.Table4.map((e: any) => e.MappedId).toString();
        this.Expense.SelectType = 'update';
        this.LastWebESSApplicabilityId = this.Expense.WebESSApplicabilityId;

        if (this.Expense.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.Expense.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.Expense.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table4.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.Expense.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table4.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.Expense.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.Expense.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.Expense.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.Expense.WebESSApplicabilityId == 8) {
          response.Table4.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.Expense.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.Expense.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.Expense.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ESS_ExpenseCategoryMasterSelect();
        this.ESS_VehicleMasterSelect();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ESS_ExpenseRule_InsertUpdate() {
    await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.Expense.IsReportToBeSubmittedBefore && (parseInt(this.Expense.ReportToBeSubmittedBefore) > 365 || parseInt(this.Expense.ReportToBeSubmittedBefore) <= 0)) {
      this.toast.show({ message: 'Please enter report submitted before between 1 to 365 days', type: toastTypeEnum.warning });
    } else if (this.Expense.EmpType != 'FRONT' && this.Expense.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.Expense.ESS_ExpenseCategoryLimitationsRule.length <= 0 && this.Expense.ESS_ExpenseMilageLimitationsRule.length <= 0) {
      this.toast.show({ message: "Please enter atleast one category or mileage limitation", type: toastTypeEnum.warning });
    }
    // else if (this.Expense.ESS_ExpenseMilageLimitationsRule.length <= 0) {
    //   this.toast.show({ message: "Please enter atleast one mileage limitation", type: toastTypeEnum.warning });
    // } 
    else if (this.Expense.WebESSApplicabilityId == null) {
      this.toast.show({ message: "Please select applicability", type: toastTypeEnum.warning });
    } else if (this.Expense.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: "Please select sub applicability", type: toastTypeEnum.warning });
    } else if (this.Expense.WebESSApplicabilityId == 0 && this.Expense.DefaultRule) {
      this.toast.show({ message: "Applicability none not allow for default rule yes", type: toastTypeEnum.warning });
    } else if (this.Expense.ESS_ExpenseCategoryLimitationsRule.filter((item: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.ESS_ExpenseCategoryMasterId === item.ESS_ExpenseCategoryMasterId &&
        this.dateFormat.format(t.EffectiveDateObj) === this.dateFormat.format(item.EffectiveDateObj)
      ))
    ).length != this.Expense.ESS_ExpenseCategoryLimitationsRule.length) {
      this.toast.show({ message: "Duplicate record found in category", type: toastTypeEnum.warning });
    } else if (this.Expense.ESS_ExpenseMilageLimitationsRule.filter((item: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.ESS_VehicleMasterId === item.ESS_VehicleMasterId &&
        this.dateFormat.format(t.EffectiveDateObj) === this.dateFormat.format(item.EffectiveDateObj)
      ))
    ).length != this.Expense.ESS_ExpenseMilageLimitationsRule.length) {
      this.toast.show({ message: "Duplicate record found in mileage limitation", type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.Expense.ESS_ExpenseRuleID == 0) || (this.common.PageRight.IsEdit && this.Expense.ESS_ExpenseRuleID > 0)) {
          if (result) {
            this.isDisabled = true;
            if (!this.Expense.IsReportToBeSubmittedBefore) {
              this.Expense.ReportToBeSubmittedBefore = 0;
            }
            this.Expense.ESS_ExpenseCategoryLimitationsRule.forEach((element: any) => {
              element.EffectiveDate = this.dateFormat.format(element.EffectiveDateObj);
              if (element.ExpenseCategoryAtActual) {
                element.MaxExpenseAmountLimit = null;
                element.MaxExpenseCount = null;
              }
              if (!element.IsReceiptRequired) {
                element.ReceiptRequiredLimit = 0;
              }
            });

            this.Expense.ESS_ExpenseMilageLimitationsRule.forEach((element: any) => {
              element.EffectiveDate = this.dateFormat.format(element.EffectiveDateObj);
              if (element.ExpenseMilageAtActual) {
                element.MileageRate = null;
                element.MileageLimit = null;
              }
              if (!element.IsReceiptRequired) {
                element.ReceiptRequiredLimit = 0;
              }
            });

            this.Expense.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.Expense.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();
            this.expense.ESS_ExpenseRule_InsertUpdate(this.Expense).subscribe({
              next: (response) => {
                if (response.Error_Code == "01") {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  close() {
    this.router.navigate(['/setting/expensepolicies/']);
  }
}
